import { IProcessRequest } from "../../model/request/IProcessRequest";
import { IDanhSachTroCapDuyetRequest } from "../../model/request/tro-cap/IDanhSachTroCapDuyetRequest";
import { IDanhSachTroCapSelectByLopsRequest } from "../../model/request/tro-cap/IDanhSachTroCapSelectByLopsRequest";
import { IDanhSachTroCapTongTinChiRequest } from "../../model/request/tro-cap/IDanhSachTroCapTongTinChiRequest";
import { apiClient } from "../apiClient";
export const TRO_CAP_ENDPOINT = "tro-cap";
export const troCapApi = {
  SelectAllByLop: (request: IDanhSachTroCapSelectByLopsRequest) =>
    apiClient.post(`${TRO_CAP_ENDPOINT}/select-by-lops`, request),
  SelectTongTinChiBySinhViens: (request: IDanhSachTroCapTongTinChiRequest) =>
    apiClient.post(`${TRO_CAP_ENDPOINT}/select-tong-tin-chi-by-svs`, request),
  DuyetAsync: (request: IProcessRequest<IDanhSachTroCapDuyetRequest>) =>
    apiClient.put(
      `${TRO_CAP_ENDPOINT}/duyet?process_id=${request.process_id}`,
      request.payload
    ),
  HuyDuyetAsync: (request: IProcessRequest<IDanhSachTroCapDuyetRequest>) =>
    apiClient.put(
      `${TRO_CAP_ENDPOINT}/huy-duyet?process_id=${request.process_id}`,
      request.payload
    ),
};
